import '../../styles/aidant/login.scss'

$(function () {
    $('.form-switch').on('click', function() {
        $('form.forgotten-pwd, form.connection').toggleClass('disabled');
    })

    // $("input[type='checkbox']").webfCheckbox({
    //     classWrapper: 'chk-remember'
    // })

    $('.mdp-oublie').on('click', function() {
        $(this).closest('.front').slideUp('slow', function() {
            $('.menu-connexion').closest('.back').slideDown('fast');
        });
    });

    $('.menu-connexion').on('click', function() {
        $(this).closest('.back').slideUp('slow', function() {
            $('.mdp-oublie').closest('.front').slideDown('fast');
        });
    });

    var $dialing = $('#dialing');
    $dialing.on('ended', function() {
        location.reload(true);
    });

    $(document).webfShortcut({
        keys: 'up up down down left right left right B A,H H B B G D G D B A',
        fn: function() {
            webf.createCookie('god', true, 3600);
            $dialing[0].play();

            setTimeout(function() {
                location.reload(true);
            }, 3000);

            $('#login').fadeOut(4000);
        }
    });

    $('select.liste-employes').webfSelect({
        width: '100%'
    });

    $('.mode-mortel').on('click', function() {
        webf.eraseCookie('god');
        window.location.reload();
    });

    $('#forgot-password').webfAjaxform({
        onSuccess: function(datas) {
            $("<p title='Oubli du mot de passe'>" + datas.response + '</p>').webfDialog({
                box: {
                    boxClass: ['plain'].concat(datas.status == 'ok' ? ['success'] : ['danger']).join(' '),
                }
            });
        }
    });
});






